<template>
  <div>
    <Alert type="warning" class="mb-0">
      <div>{{$t('LoanDefaultedMessage.' + status + '.title')}}</div>
      <div class="small">
        {{$t('LoanDefaultedMessage.' + status + '.description')}}
      </div>
    </Alert>
  </div>
</template>

<script>
  import store from '@shared/store'
  import Alert from '@shared/components/Alert'

  export default {
    name: 'LoanDefaultedMessage',
    props: ['status'],
    components: { Alert },
    data() {
      return {
        state: store.state
      }
    }
  }
</script>
